export const ON_CLOSE_MEATBALLS = 'onCloseMeatballs';
